import { useTranslation } from 'react-i18next';
import { NotificationContentRead } from './notificationContent/NotificationContentRead';
import { NotificationContentWrite } from './notificationContent/NotificationContentWrite';

const NotificationFooter = ({ textContent, onChange, canEdit }) => {
  const { t: translator } = useTranslation();

  if (canEdit) {
    return (
      <NotificationContentWrite
        textContent={textContent}
        onChange={onChange}
        header={translator('notificationContent.footer')}
        ariaLabel={translator('ariaLabel.notificationFooterWrite')}
      />
    );
  }
  return (
    <NotificationContentRead
      textContent={textContent}
      header={translator('notificationContent.footer')}
      ariaLabel={translator('ariaLabel.notificationFooterRead')}
    />
  );
};

export { NotificationFooter };
